import { render, staticRenderFns } from "./SnapshotImport.vue?vue&type=template&id=27fd7a50&scoped=true&"
import script from "./SnapshotImport.vue?vue&type=script&lang=ts&"
export * from "./SnapshotImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd7a50",
  null
  
)

export default component.exports